import { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import "./create-service-form.scss";
import { SingleCard } from "../../layouts";
import { useAuth } from "../../contexts/auth";
import { baseAxios } from "../../utils/config.js";
import { ServiceForm } from "./service-form.js";

export default function CreateServiceForm(props) {
  const {
    onSaved,
    onRequestClose,
    onLoadingChange,
    formId = "create-service-form",
  } = props;
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ taxesIncluded: false });
  const embedded =
    typeof onSaved === "function" || typeof onRequestClose === "function";

  const userCredentials = {
    Barcode: user.barcode,
    Role: user.userRoles,
    Organization: user.org,
    Location: user.location_id,
  };

  useEffect(() => {
    onLoadingChange?.(loading);
  }, [loading, onLoadingChange]);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);
      if (
        !userCredentials.Role.includes(6) &&
        !userCredentials.Role.includes(3) &&
        !userCredentials.Role.includes(2)
      ) {
        toast.error("User Not authorized, please check your role", {
          duration: 5000,
        });
        setLoading(false);
        return;
      }

      if (
        !formData.current.freeService &&
        !formData.current.price1 &&
        !formData.current.price2 &&
        !formData.current.price3 &&
        !formData.current.price4 &&
        !formData.current.price5
      ) {
        toast.error(
          "At least one price level must be set if the service has a cost.",
          { duration: 3000 }
        );
        setLoading(false);
        return;
      }

      try {
        const response = await baseAxios.post(
          "/services/create",
          formData.current
        );

        if (response.status === 201) {
          toast.success("Service Created", { duration: 3000 });
          if (typeof onSaved === "function") {
            onSaved();
          } else {
            setTimeout(() => {
              navigate(0);
            }, 3000);
          }
        }
      } catch (e) {
        if (e.status === 400) {
          toast.error(e.data.message, { duration: 5000 });
        } else {
          toast.error("Service creation failed, please try again", {
            duration: 5000,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [navigate, onSaved, userCredentials.Role]
  );

  const formBody = (
    <form id={formId} className="create-service-form" onSubmit={onSubmit}>
      <ServiceForm
        formData={formData}
        loading={loading}
        embedded={embedded}
      />
    </form>
  );

  if (embedded) {
    return formBody;
  }

  return <SingleCard title="Add new Service">{formBody}</SingleCard>;
}
